export const microphoneKeys = {
    SPEAKING_ON_MUTE: 'SPEAKING_ON_MUTE',
    SPEAKER_VOLUME: 'SPEAKER_VOLUME',
}
